module.exports = __webpack_public_path__ + "static/media/400036_01.1794f667.png";